import React from 'react';

import { useRouter } from 'next/router';

import { mixpanelObject } from 'src/utils/analytics';

import * as customStyled from './styles';
import { ctaEvent } from '../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { shouldRedirectToPWA } from '../../../utils/cardsUrlGenerator';
import { TagProps, TagTypes } from '../types';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CTA,
  MIXPANEL_ELEMENT
} from '../../../utils/analytics/mixpanel/mixpanelConstants';

const metaDataMixpanelEvents = (mixpanelElementName: string) => {
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, mixpanelElementName);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  ctaEvent();
};

const Tag: React.FC<TagProps> = ({
  tagType,
  link,
  text,
  textColor,
  fontSize,
  fontWeight,
  showDot = false,
  mixpanelElementName,
  index
}) => {
  const router = useRouter();
  const tagClickHanlder =
    (link: string, mixpanelElementName?: string) =>
    (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      if (mixpanelElementName) {
        metaDataMixpanelEvents(mixpanelElementName);
      }
      const isPWAPage = shouldRedirectToPWA(link);
      if (isPWAPage) {
        window.location.href = link;
      } else {
        router.push(link);
      }
    };

  const getTagStyles = (textColor?: string) => {
    switch (tagType) {
      case TagTypes.SOLID:
        return customStyled.solidTagStyles;
      case TagTypes.OUTLINE:
        return customStyled.outlineTagStyles;
      case TagTypes.LINK:
        return customStyled.linkTagStyles(textColor);
      default:
        return;
    }
  };

  /**
   * ToDo: revisit to be more specific on tag type in data-testid.
   * Ex.
   * content-year
   * content-type
   * content-age-rating
   * content-duration
   */
  return (
    <div data-testid={`content-tag-${index}`}>
      {tagType === TagTypes.LINK && link ? (
        <a
          href={link}
          onClick={tagClickHanlder(link, mixpanelElementName)}
          css={[
            customStyled.commonTagStyles(
              fontSize,
              textColor,
              fontWeight,
              showDot
            ),
            getTagStyles(textColor)
          ]}>
          {text}
        </a>
      ) : (
        /**
         * Actual content tile for tv-shows comes below along with age rating, duration etc,
         * Should we add h2/h3 tag for it. Need to confirm with Design.
         */
        <div
          data-testid="textStyle"
          css={[
            customStyled.commonTagStyles(
              fontSize,
              textColor,
              fontWeight,
              showDot
            ),
            getTagStyles()
          ]}>
          {text}
        </div>
      )}
    </div>
  );
};

export default Tag;
